<template>
  <div>
    
    <!-- What We Do -->
    <div class="whatwedo-container">
      <div class="container wwd-bb">
        <div class="title mb-3 main-color" 
          :style="'color:'+row.subTitleColor1+' !important'">
          {{ row.subTitle1 }} 
          <span class="bg-title-line" :style="'color:'+row.lineColor1+' !important'"></span>
        </div>
        <div class="wwe-row">
          <div class="wwe-left">
            <img v-if="row.image1" :src="row.image1" class="img-fluid" :alt="row.title1" />
            <div class="wwe-widget">
              <div class="bg-title mb-3 white-color"
                v-html="row.title1"
                :style="'color:'+row.titleColor1+' !important'">
              </div>
              <router-link v-if="row.button1" :to="row.redirect1"
                class="btn-line">{{ row.button1 }}
              </router-link>
            </div>
          </div>


          <div class="wwe-right">
            <div class="wwe-card">
              <img v-if="row.image2" :src="row.image2" class="img-fluid" :alt="row.title2" />
              <div class="wwe-details">
                <div class="title main-color"
                  v-html="row.title2"
                  :style="'color:'+row.titleColor2+' !important'">
                </div>
                <div class="text"
                  v-html="row.content2"
                  :style="'color:'+row.contentColor2+' !important'">
                </div>
                <router-link v-if="row.button2" :to="row.redirect2"
                  class="read-more-line">{{ row.button2 }}
                </router-link>
              </div>
            </div>

            <div class="wwe-card">
              <img v-if="row.image3" :src="row.image3" class="img-fluid" :alt="row.title3" />
              <div class="wwe-details">
                <div class="title main-color"
                  v-html="row.title3"
                  :style="'color:'+row.titleColor3+' !important'">
                </div>
                <div class="text"
                  v-html="row.content3"
                  :style="'color:'+row.contentColor3+' !important'">
                </div>
                <router-link v-if="row.button3" :to="row.redirect3"
                  class="read-more-line">{{ row.button3 }}
                </router-link>
              </div>
            </div>

            <div class="wwe-card">
              <img v-if="row.image4" :src="row.image4" class="img-fluid" :alt="row.title4" />
              <div class="wwe-details">
                <div class="title main-color"
                  v-html="row.title4"
                  :style="'color:'+row.titleColor4+' !important'">
                </div>
                <div class="text"
                  v-html="row.content4"
                  :style="'color:'+row.contentColor4+' !important'">
                </div>
                <router-link v-if="row.button4" :to="row.redirect4"
                  class="read-more-line">{{ row.button4 }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- What We Do -->

  </div>
</template>

<style scoped>
.read-more-line {
  color: #458FCC;
  font-size: 15px;
  font-weight: 600;
}
</style>

<script>
export default {
  name: "Section1",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
